(function ($) {
    var dot = '.';

    var itemClass = 'header-nav__item';
    var linkClass = 'header-nav__link';
    var subToggleClass = 'header-nav__sub-toggle';
    var subListClass = 'header-nav__sub-list';

    var subToggleClassVisible = subToggleClass + '--visible';
    var subListClassVisible = subListClass + '--visible';

    // Show and hide the second level lists in the main navigation menu by
    // clicking on additional arrow links or buttons to the side of each main
    // navigation link.
    $(function () {
        var subLists = $(dot + subListClass);

        subLists.each(function (subListIndex, subListNode) {
            var subList = $(subListNode);
            var item = subList.parent();
            var link = item.find(dot + linkClass);
            var subToggle = item.find('> ' + dot + subToggleClass);

            // Second level toggle link does not exist? Add the link after the
            // main navigation link and before the second level list.
            if (subToggle.length === 0) {
                subToggle = $('<a href="#" class="' + subToggleClass + '"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7,10L12,15L17,10H7Z" /></svg> <span class="screen-reader-text">show/hide links</span></a>');
                link.after(subToggle);
            }

            // When the user clicks on the toggle link, toggle the "visible"
            // class on this second level list and remove the "visible" class
            // from all other second level lists.
            subToggle.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                subList.toggleClass(subListClassVisible);
                subLists.not(subList).removeClass(subListClassVisible);

                subToggle.toggleClass(subToggleClassVisible);
                $(dot + subToggleClass).not(subToggle).removeClass(subToggleClassVisible);
            });
        });

        // Hide all second level lists when the user clicks elsewhere on the page.
        $('html').on('click', function (e) {
            subLists.removeClass(subListClassVisible);
            $(dot + subToggleClass).removeClass(subToggleClassVisible);
        });
    });
})(jQuery);
